var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1078 22.3929C30.0743 22.3929 31.6685 23.9871 31.6685 25.9537V27.4079C31.6685 28.3157 31.3847 29.2008 30.8569 29.9395C28.4092 33.3646 24.4124 35.0614 18.997 35.0614C13.5805 35.0614 9.58577 33.3638 7.14402 29.937C6.61841 29.1993 6.33594 28.3161 6.33594 27.4103V25.9537C6.33594 23.9871 7.93013 22.3929 9.89666 22.3929H28.1078ZM18.997 3.40039C23.3693 3.40039 26.9137 6.9448 26.9137 11.3171C26.9137 15.6893 23.3693 19.2337 18.997 19.2337C14.6247 19.2337 11.0803 15.6893 11.0803 11.3171C11.0803 6.9448 14.6247 3.40039 18.997 3.40039Z",
    fill: "#61696B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.f1dfa8047442436dcf794c644055640d.svg";
export { ForwardRef as ReactComponent };